import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x=".5" y=".5" width="19" height="19" rx="3.5" fill="#fff" /><path d="M0 3.5A3.5 3.5 0 013.5 0h12A3.5 3.5 0 0119 3.5V6H0z" fill="#D25D54" /><rect x=".5" y=".5" width="19" height="19" rx="3.5" stroke="#CCC" /></svg>;